import { BillingFreightItemTable } from "../../../ar/src/BillingFreightItemTable";
import { OrderHandlingRequirements } from "../../../dispatch/src/OrderHandlingRequirements";
import { ShipperPONums } from "../../../dispatch/src/ShipperPONums";
import { EdiBillingOverview } from "../EdiBillingOverview";
import { EdiBillingRates } from "../EdiBillingRates";
import { EdiFuncAck } from "../EdiFuncAck";
import { EdiMapErrors } from "../EdiMapErrors";
import { Button, Checkbox, DataHeader, DataSource, Image, Label, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiBilling extends Layout {
    buttonGoToOrder: Button;
    buttonOpenClassic: Button;
    buttonOrderHistory: Button;
    checkBalanceDue: Checkbox;
    checkRebill: Checkbox;
    checkboxFloorLoadedFreight: Checkbox;
    checkboxHighValue: Checkbox;
    checkboxIntercompany: Checkbox;
    checkboxIsSplitBill: Checkbox;
    checkboxPreloaded: Checkbox;
    checkboxPrinted: Checkbox;
    checkboxReadyToProcess: Checkbox;
    checkboxRoundTrip2: Checkbox;
    checkboxRoundTrip: Checkbox;
    checkboxTeamsRequired: Checkbox;
    dataheaderOrders: DataHeader;
    dfXref: Label;
    ediStopsTable: Table;
    imageAddHandlingReq: Image;
    labelCreditBadge: Label;
    labelCustomsBroker: Label;
    labelCustomsCoBroker: Label;
    labelHazmatCommodity: Label;
    labelHoldBadge: Label;
    labelInvoiceHistoryView: Label;
    labelMovementView: Label;
    labelOrderView: Label;
    labelPreferredBorderCrossings: Label;
    labelStatusBadge: Label;
    labelTemperatureRange: Label;
    layoutEdiBillingRates: EdiBillingRates;
    layoutEdiFunctionalAck: EdiFuncAck;
    layoutFreightItems: BillingFreightItemTable;
    layoutHandlingReqs: OrderHandlingRequirements;
    layoutImageTable: Layout;
    layoutMapErrors: EdiMapErrors;
    layoutOverview: EdiBillingOverview;
    layoutShipperPONums: ShipperPONums;
    panel10: Panel;
    panel11: Panel;
    panel12: Panel;
    panel13: Panel;
    panel1: Panel;
    panel3: Panel;
    panel6: Panel;
    panelBorderCrossings: Panel;
    panelBrokerLocations: Panel;
    panelCbpCrossing: Panel;
    panelCbsaCrossing: Panel;
    panelCommodityCheckboxes: Panel;
    panelCommodityExtra: Panel;
    panelCommodityHazmat: Panel;
    panelCustoms: Panel;
    panelCustomsBrokers: Panel;
    panelDataFusion: Panel;
    panelDataHeaderUpdateOnly: Panel;
    panelFuncAck: Panel;
    panelGeneralUpdate: Panel;
    panelHazmatComponents: Panel;
    panelInvoiceHistoryTab: Panel;
    panelMovementTab: Panel;
    panelOrderTab: Panel;
    panelOrderTabs: Panel;
    panelTemperatureRange: Panel;
    sourceBillingFreightGroup: DataSource;
    sourceBrltlOrderHdrXFgp: DataSource;
    sourceEdiBillingDetails: DataSource;
    sourceEdiFunctionalAck: DataSource;
    sourceEdiMapError: DataSource;
    sourceEdiStop: DataSource;
    sourceEquipMatchDetail: DataSource;
    sourceMovement: DataSource;
    sourceOrders: DataSource;
    sourceResponsibleHist: DataSource;
    sourceStop: DataSource;
    stopsTable: Table;
    switchHazmatRouting: Switch;
    switchHoldLoad: Switch;
    switchRecurringOrder: Switch;
    tabAccessorials: Tab;
    tabBrltlFreightItems: Tab;
    tabCommodity: Tab;
    tabCustoms: Tab;
    tabDataFusion: Tab;
    tabEquipment: Tab;
    tabErrors: Tab;
    tabFunctionalAck: Tab;
    tabGeneral: Tab;
    tabImages: Tab;
    tabInvoiceProcessing: Tab;
    tabOverview: Tab;
    tabRate: Tab;
    tabStops: Tab;
    tableEquipmentRequirementsAsset: Table;
    tableEquipmentRequirementsBrokerage: Table;
    tabsetErrors: Tabset;
    tabsetUpdateBilling: Tabset;
    textBoxProNbr: Textbox;
    textReadyToSend: Textbox;
    textbox1GsControlNo: Textbox;
    textboxAgentPayeeId: Textbox;
    textboxBillDate: Textbox;
    textboxBillType: Textbox;
    textboxBillTypeLabel: Textbox;
    textboxBillingUserId: Textbox;
    textboxBlnum: Textbox;
    textboxBolNote: Textbox;
    textboxBolRecvDate: Textbox;
    textboxBrkQualProfile: Textbox;
    textboxBrokerLocationId: Textbox;
    textboxBrokerageWorkflowId: Textbox;
    textboxCarrierTractor: Textbox;
    textboxCarrierTrailer: Textbox;
    textboxCbpCrossingDate: Textbox;
    textboxCbpCrossingLocationId: Textbox;
    textboxCbpCrossingReason: Textbox;
    textboxCbsaCrossingDate: Textbox;
    textboxCbsaCrossingLocationId: Textbox;
    textboxCbsaCrossingReason: Textbox;
    textboxCobrokerLocationId: Textbox;
    textboxCommodity: Textbox;
    textboxCommodityId: Textbox;
    textboxConsigneeRefno: Textbox;
    textboxControllingCarrierPro: Textbox;
    textboxCopyFromCompany: Textbox;
    textboxCopyFromOrderId: Textbox;
    textboxCopyToCompany: Textbox;
    textboxCopyToOrderId: Textbox;
    textboxCustomerId: Textbox;
    textboxDefMoveType: Textbox;
    textboxDeliveryDate: Textbox;
    textboxDriverId: Textbox;
    textboxEnteredUserId: Textbox;
    textboxEquipmentTypeIdEquipment: Textbox;
    textboxEquipmentTypeIdGeneral: Textbox;
    textboxExternalInvoiceno: Textbox;
    textboxFrtGrpProNbr: Textbox;
    textboxHazmatCode: Textbox;
    textboxHoldReason: Textbox;
    textboxInvoiceNoString: Textbox;
    textboxInvoiceNumber: Textbox;
    textboxInvoiceRecvDate: Textbox;
    textboxOperationsUser: Textbox;
    textboxOrderLength: Textbox;
    textboxOrderMode: Textbox;
    textboxOrderNumber: Textbox;
    textboxOrderOrderedBy: Textbox;
    textboxOrderType: Textbox;
    textboxOrderValue: Textbox;
    textboxOrderedDate: Textbox;
    textboxOrderedMethod: Textbox;
    textboxPartnerName: Textbox;
    textboxPieces: Textbox;
    textboxPlanningComment: Textbox;
    textboxPreloadTrailerId: Textbox;
    textboxRateSource: Textbox;
    textboxRecurringOrderId: Textbox;
    textboxRevenueCodeId: Textbox;
    textboxShipDate: Textbox;
    textboxShipMatchDescr: Textbox;
    textboxShipMatchType: Textbox;
    textboxStatus: Textbox;
    textboxTemperatureMax: Textbox;
    textboxTemperatureMin: Textbox;
    textboxTractorId: Textbox;
    textboxTractorType: Textbox;
    textboxTrailer2Id: Textbox;
    textboxTrailerId: Textbox;
    textboxTransmitted: Textbox;
    textboxWeight: Textbox;
    textboxXferred2billingDt: Textbox;
    txtBatch: Textbox;
    txtCorrectionIndicator: Textbox;
    txtCreateDate: Textbox;
    txtDirection: Textbox;
    txtError: Textbox;
    txtId: Textbox;
    txtModifiedDate: Textbox;
    txtModifiedUser: Textbox;
    txtServiceCode: Textbox;
    txtShipmentId: Textbox;
}
